<template>
  <div>
    <CCard class="bg-style2" v-if="isCard">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"><CIcon :name="icon" size="lg"/> {{ caption }}</span>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <ul class="timeline" id="timeline">
              <li class="li" :class="(objs.complete === true)?'complete':''" v-for="objs in item">
                <div class="timestamp">
                  <span class="author" v-if="!(objs.author === '')">{{ objs.author }}</span>
                  <span class="date" v-if="!(objs.date === '')">{{ objs.date }}</span>
                </div>
                <div class="status" v-if="!(objs.state === '')"  >
                  <samp> {{objs.state}} </samp>
                </div>
              </li>
            </ul>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

<!--    {{objs.historys[0].status}}-->
    <CRow v-if="!isCard" class="mb-4">
      <CCol>
        <div style="width: 100px; height: 100px; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-align: center;" class="font-weight-bold text-white bg-gradient-success">
          IDP  <br>
          Porgress
        </div>
      </CCol>
      <CCol col="10">
        <div class="overflow-auto">
          <ul class="timeline" id="timeline" style="width: max-content" >
            <li class="li" :class="(objs.complete === true)?'complete':''" v-for="objs in item">
              <div class="timestamp">
                <span class="author" v-if="!(objs.author === '')">{{ objs.author }}</span>
                <span class="date" v-if="!(objs.date === '')">{{ objs.date }}</span>
              </div>
              <div class="status" v-if="!(objs.state === '')"  >
                <samp> {{objs.state}} </samp>
              </div>
            </li>
          </ul>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>


import {mapGetters} from 'vuex'
export default {
  name: 'TimelineDanger',
  props: {
    caption: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "cil-layers"
    },
    isCard: {
      type: Boolean,
      default: false
    },
    item:{
      type:Array,
      default: () => [
        {author :"เริ่มกระบวยการ", date : "จัดทำแผน IDP", state : " ", complete: true},
        {author :"พนักงานจัดทำ", date : "แผน IDP", state : " ", complete: true},
        {author :"ผู้บังคับบัญชา", date : "พิจาราณาแผน", state : " ", complete: true},
        {author :"ดำเนินการพัฒนา", date : "ตามแผน IDP", state : " ", complete: false},
        {author :"สิ้นสุดกระบวนการพัฒนา", date : "ผลการพัฒนา", state : " ", complete: false}
      ]
    },

    objs : {
      type: Object,
      default: () => {
      }
    }
  },
  data: function () {
    return {


    }

  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();
    },





  },



  computed:{
    ...mapGetters({
      lang : "setting/lang",

    }),
  },

  watch: {
    objs(value) {
    }
  }

}
</script>
<style scoped>

ul> .li.complete .status {
  border-top: 2px solid #ac1515;
}
ul> .li.complete .status:before {
  background-color: #ac1515;
  border: none;
  transition: all 200ms ease-in;
}
ul> .li.complete .status {
  color: #ac1515;
}
</style>


